
<template>
    <div id="app">
         <router-view/>
    </div>
</template>
<!-- <template>
  <div id="app">
    <router-view/>
  </div>
</template> -->
<script>
export default {
   data (){
      return{}
    },
  
  // beforeCreate: function() {
  //    console.group('------beforeCreate创建前状态------');
  // },
  created: function() {
    //this.query_config()
    //console.log('版本号：'+ process.env.UPDATEDATE);
    // console.log('版本号 3-29')
  },
  /* beforeMount: function() {
    console.group('------beforeMount挂载前状态------');
  },
  mounted: function() {
    console.group('------mounted 挂载结束状态------');
  },
  beforeUpdate: function () {
    console.group('beforeUpdate 更新前状态===============》');
  },
  updated: function () {
    console.group('updated 更新完成状态===============》');
  },
  beforeDestroy: function () {
    console.group('beforeDestroy 销毁前状态===============》');
  },*/
  destroyed: function () {
    console.group('destroyed 销毁完成状态===============》');
    this.$notify({
      title: '退出登录',
      message: '感谢您的使用',
      type: 'success'
    });
    this.$store.commit('$_removeStorage');
    this.$router.push({name:'Index'});
  },
  methods:{
    query_config(){
        // var data = ("1504021904070020，1504021904070042，1504021904070019，1504021904070090，1504021904070025，1504021904070022，1504021904070023，1504021904070024").split("，");
        // var str = "";
        // for (var i = 0 ; i < data.length ; i++){
        // str+=("\ndelete from censortasks where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from censoropinions where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from censorproblem where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from censortaskdetail where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from censortaskdce where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from censortasklog where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from drawing where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from greenbuildingdesign where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from projectarchives where ProjectID in (select ProjectID from projects where TaskID = '"+data[i]+"');");
        // str+=("\ndelete from projects where TaskID = '"+data[i]+"';");
        // str+=("\ndelete from taskarchives where TaskID = '"+data[i]+"';");
        // str+=("\n\ndelete from taskarchivesattachment where TaskID = '"+data[i]+"';");
        // }
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  color: #2c3e50;
}

.striped_table,.striped_table th{
		background:#FAFAFA !important
	}
	.striped_table td{
		padding:5px 0 !important
	}

	.striped_table td .cell,.striped_table th .cell{
		font-size: 16px !important;
	}

	.message_table{
		background:#FAFAFA !important
	}
  .el-table tbody tr:hover>td{
    background-color: #d0e7fc !important;
}
  .el-table tbody tr,.el-table tbody tr td,.el-table thead tr,.el-table thead tr td{
    color:#333;
    font-size: 16px;
}
  .el-menu-item ,.el-submenu__title{
    color: #000;
    font-size: 16px;
  }
  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #d0e7fc!important;
}
.el-tree-node__content:hover {
    background-color: #d0e7fc !important;
}
.el-menu-item.is-active {
  background-color: #d0e7fc;
    color: #409EFF;
}
.el-menu-item:hover{
  background-color: #d0e7fc;
}
</style>



// WEBPACK FOOTER //
// src/App.vue